import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';

export function TextInput(props) {
  const id = props.id ? props.id : _.uniqueId('input-');

  return (
    <input
      type="text"
      className={props.className}
      placeholder={props.placeholder}
      name={props.name}
      id={id}
      value={props.value}
      onChange={props.onChange}
      onClick={props.onClick}
      disabled={props.disabled}
      aria-label={props.ariaLabel || props.placeholder}
      onBlur={props.onBlur}
    />
  );
}

TextInput.propTypes = {
  className: PropTypes.string,
  placeholder: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  ariaLabel: PropTypes.string,
};

TextInput.defaultProps = {
  className: null,
  placeholder: null,
  id: null,
  name: null,
  disabled: false,
  ariaLabel: null,
  onClick: _.noop,
  onBlur: _.noop,
};
